<template>
    <div class="text-center text-secondary pt-5 pb-5 bg-primary">
        <b-container class="px-4">
            <b-row class="gx-5 justify-content-center">
                <b-col xl="8">
                    <small class="mb-4 font-monospace">
                        {{this.$store.getters.event.name}}
                    </small>
                </b-col>
                <b-col cols="12" class="mt-2">
                    <b-img fluid :class="[`${landscape===true? 'w-50':'w-75'}`]" :src="require('@/assets/img/logo_evento.png')"></b-img>
                </b-col>
                <b-col xl="8">
                    <h5 class="mb-4 font-monospace pt-2 text-white">
                        {{this.event.text_extra}}
                    </h5>
                </b-col>
                <b-col xl="8" class="mt-2 text-white" v-if="isLoggedIn">
                    <h4 v-if="assistantName" class="pt-0 text-center font-alt">
                        <span class="text-secondary">Bienvenido(a)</span> {{assistantName}}
                    </h4>
                </b-col>
                <b-col xl="8" class="mt-2">
                    <h3 class="pt-3 text-center font-monospace">
                        Podrá enviar preguntas en cualquier momento al ponente.
                    </h3>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'HeaderWebApp',
    data() {
        return {
            landscape: false,
        }
    },
    mounted () {
        window.onresize = () => {
            this.landscape = window.innerWidth > window.innerHeight
        }
        this.landscape = window.innerWidth > window.innerHeight
    },
    computed: {
        isLoggedIn : function() {
            return this.$store.getters.isLoggedIn
        },
        event() { return this.$store.getters.event },
        room: function() { return this.$store.getters.room },
        assistantName : function() {return this.$store.getters.assistant.name},
    },
})
</script>

<style lang="scss" scoped>
@import '../../../styles/app';

</style>